"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  showTable: {
    table: {
      label: '中文标题',
      labelEn: '英文标题',
      value: '值',
      operat: '操作'
    }
  }
};